import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { IconBadge } from '../../components/ui/IconBadge';
import './NotFound.css';

export function NotFound() {
  return (
    <section className="not-found">
      <IconBadge icon={Compass} tone="primary" size="lg" />
      <h1>Page introuvable</h1>
      <p>Cette page n'existe pas ou plus.</p>
      <Link to="/">
        <Button>Retour à l'accueil</Button>
      </Link>
    </section>
  );
}
